<template>
  <div class="profile">
    <div class="container-fluid">
      <nav class="navbar navbar-expand-lg navbar-light bg-light">
        <a class="navbar-brand" href="#">收貨資訊</a>
      </nav>

      <!--  /////////////////////////////// -->

      <div class="title pt-3">Step3.寄送方式</div>
      <div class="card">
        <div class="card-body">
          <div class="form-group">
            <label for="name"
              >取件人姓名（貨到付款取貨須[出示證件]，請填寫取件人證件上之名字）</label
            >
            <input
              type="text"
              class="form-control"
              id="userName"
              aria-describedby="nameHelp"
              placeholder="收貨人姓名"
              v-model="from.name"
            />
          </div>
          <div class="form-group">
            <label for="phone"
              >取件人手機（商品抵達門市會以簡訊通知，請務必注意訊息（EX:09
              開頭））</label
            >
            <input
              type="number"
              class="form-control"
              id="userPhone"
              placeholder="收貨人電話"
              v-model="from.phone"
            />
          </div>
          <div class="form-group">
            <label for="name">電子郵件（訂單狀態通知用）</label>
            <input
              type="text"
              class="form-control"
              id="userEmail"
              :for="type - email"
              placeholder="電子郵件"
              v-model="from.email"
            />
          </div>

          <div class="form-group">
            <label>國際運輸方式</label>
            <b-form-radio
              v-model="internationalTransportationSelected"
              name="internationalTransportation-radios"
              value="空運"
              >空運 (食品僅限空運)</b-form-radio
            >
            <b-form-radio
              v-model="internationalTransportationSelected"
              name="internationalTransportation-radios"
              value="海快"
              >海快 (需超過10公斤)</b-form-radio
            >
          </div>
          <div class="form-group">
            <label>海關稅收</label>
            <div v-if="internationalTransportationSelected == '空運'">
              <b-form-radio v-model="taxSelected" name="tax-radios" value="包稅"
                >包稅</b-form-radio
              >
            </div>
            <div v-else>
              <b-form-radio
                v-model="taxSelected"
                name="tax-radios"
                id="notax-radios"
                value="不包稅"
                >不包稅</b-form-radio
              >
            </div>
          </div>
          <b-alert show style="text-align: left">
            運輸時間：
            <br />空運大約:2~3天 <br />海快大約:7~10天
          </b-alert>

          <div class="form-group">
            <label for="shippingTypeSelected">選擇取貨方式</label>
            <b-form-select
              v-model="shippingTypeSelected"
              :options="shippingTypeOptions"
            ></b-form-select>
          </div>

          <div v-show="isStoreShow">
            <div class="form-group">
              <div class="form-group col-md-12">
                <label for="inputStore">選擇超商：</label>
                <select
                  id="inputStore"
                  class="form-control"
                  v-model="selectedStore"
                >
                  <option
                    v-for="(storeOption, index) in storeOptions"
                    v-bind:key="(storeOption, index)"
                    v-bind:value="storeOption.value"
                  >
                    {{ storeOption.text }}
                  </option>
                </select>
              </div>
              <button
                class="btn btn-success btn-lg btn-block"
                @click="selectStore()"
              >
                +新增門市
              </button>
            </div>
            <div v-if="mapInfo != null">
              <label>取貨門市:{{ mapInfo.cvs_store_name }}</label>
            </div>
            <div v-if="mapInfo != null">
              <label>取貨門市地址:{{ mapInfo.cvs_address }}</label>
            </div>
            <div v-if="mapInfo != null">
              <label>取貨門市編號:{{ mapInfo.cvs_store_id }}</label>
            </div>
            <b-alert show variant="danger" style="text-align: left"
              >注意超商取貨重量不能超過5公斤，商品長x寬x高不能超過(45x30x30)，加收40元派送費</b-alert
            >
          </div>

          <div v-show="ishomeDeliveryShow">
            <div class="form-group">
              <label for="phone">取件人地址</label>
              <input
                type="text"
                class="form-control"
                id="userAddress"
                placeholder="取件人地址"
                v-model="from.address"
              />
              <b-alert
                show
                variant="danger"
                class="mt-3"
                style="text-align: left"
                >注意宅配重量不能超過70公斤，商品長x寬x高不能超過(150x150x150)</b-alert
              >
            </div>
          </div>

          <b-alert show variant="danger" style="text-align: left">
            外島地區 澎湖、馬祖、綠島、小琉球、蘭嶼、金門 地區
            5KG以下加收100元，5KG以上加收120元，20KG以上加收330元
            <br />如果材積重量大於實際重量*2，將會以 (材積重量 + 實際重量)/2
            公斤做計算
          </b-alert>
        </div>
      </div>

      <br />
      <button class="btn btn-danger btn-lg btn-block" @click="submit()">
        確認收貨資訊，送出委託單
      </button>
      <br />
    </div>
    <loading
      loader="bars"
      :active.sync="isLoading"
      :can-cancel="true"
      :is-full-page="true"
    ></loading>
    <v-dialog />
  </div>
</template>
<style type="text/css">
input[type='number']::-webkit-outer-spin-button,
input[type='number']::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.prod-block {
  /* background-color: #ff0000; */
}

.prod-text {
  /* overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 200px; */
}

.title {
  font-size: x-large;
  padding: 10px 0px;
}

.sale-price {
  color: #ff0000;
}

.noProd {
  font-size: 30px;
  color: red;
}

.padding-top-block {
  padding-top: 10px;
}

.calculation-text {
  font-size: 13px;
  color: red;
}

.w-400 {
  /* width: 100%;
  height: 200px; */
  height: 200px;
  width: 200px;
  width: 100%;
  /* object-fit: cover; */
  /* width: 400px;
  height: 500px; */
}
</style>
<script>
import VueLoading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import axios from 'axios'
import { isMobile } from 'mobile-device-detect'

export default {
  name: 'profile',
  components: {
    loading: VueLoading,
  },
  data: function () {
    return {
      apiUrl: process.env.VUE_APP_API_URL,
      displayViews: null,
      isLoading: true,
      mapInfo: null,
      amounts: [],
      prodInfos: null,
      profileInfo: {},
      orderId: '',
      from: {
        name: '',
        phone: '',
        address: '',
        email: '',
      },
      chatbotFbUrl:
        'https://api.chatfuel.com/bots/5cf9f337dd449f0001fbc05a/users/',
      chatfuelToken:
        'uOBx3XXkpYjq1uA1O7FBzN1of2RrFwFpllox0CLMofvSfiXrgv6SkEHZAme183nZ',
      isStoreShow: false,
      ishomeDeliveryShow: true,
      shippingTypeSelected: 'delivery',
      shippingTypeOptions: [
        {
          value: 'deliveryStore',
          text: '超商取貨',
        },
        {
          value: 'delivery',
          text: '宅配',
        },
      ],
      skuSelected: '',
      selectedStore: 'UNIMARTC2C',
      checkMobile: isMobile ? '1' : '0',
      storeOptions: [
        {
          text: '7-11 超商（7-11）',
          value: 'UNIMARTC2C',
        },
      ],
      internationalTransportationSelected: '空運',
      taxSelected: '包稅',
    }
  },
  methods: {
    submit: function () {
      const vm = this
      if (vm.from.name == '') {
        vm.$toast.open({
          message: '請輸入收件人姓名',
          type: 'error',
        })
        return 0
      }
      if (vm.from.phone == '') {
        vm.$toast.open({
          message: '請輸入收件人電話',
          type: 'error',
        })
        return 0
      }

      if (vm.from.email == '') {
        vm.$toast.open({
          message: '請輸入電子郵件',
          type: 'error',
        })
        return 0
      }

      if (vm.from.address == '' && vm.mapInfo == null) {
        vm.$toast.open({
          message: '請輸入收件資訊',
          type: 'error',
        })
        return 0
      }

      if (vm.from.address != '') {
        localStorage.setItem('address', vm.from.address)
        let formDataProfile = {
          userId: localStorage.userId,
          userAddress: vm.from.address,
        }

        axios
          .post(vm.apiUrl + 'UpdateProfileForAddress', formDataProfile, {
            headers: {
              'Access-Control-Allow-Origin': '*',
              'Content-Type': 'application/json',
            },
          })
          .then(function () {
            // console.log(response.data);
            // vm.isLoading = false;
          })
          .catch(function (error) {
            // console.log(error);
            vm.$toast.open({
              message: '失敗: ' + error,
              type: 'error',
            })
            vm.isLoading = false
          })
      }

      if (vm.from.email != '') {
        localStorage.setItem('email', vm.from.email)
        let formDataProfile = {
          userId: localStorage.userId,
          email: vm.from.email,
        }

        axios
          .post(vm.apiUrl + 'UpdateProfileForEmail', formDataProfile, {
            headers: {
              'Access-Control-Allow-Origin': '*',
              'Content-Type': 'application/json',
            },
          })
          .then(function () {
            // console.log(response.data);
            // vm.isLoading = false;
          })
          .catch(function (error) {
            // console.log(error);
            vm.$toast.open({
              message: '失敗: ' + error,
              type: 'error',
            })
            vm.isLoading = false
          })
      }

      if (vm.prodInfos != undefined) {
        ;(async function postapi() {
          vm.isLoading = true

          vm.$toast.open({
            message: '建立委託單中，請稍等片刻...',
            type: 'success',
          })

          let formData = {
            prodInfos: vm.prodInfos,
            note: '',
            status: 0,
            logisticsInfo: {
              internationalTransportation:
                vm.internationalTransportationSelected,
              tax: vm.taxSelected,
            },
            productDelivery: vm.shippingTypeSelected,
            userId: localStorage.userId,
            userName: localStorage.userName,
            userImage: localStorage.userImage,
            userOrderName: vm.from.name,
            userPhone: vm.from.phone,
            mapInfo: vm.mapInfo,
            address: vm.from.address,
            email: vm.from.email,
            priceInfo: 0,
            total: 0,
          }
          // console.log("AddOrder: " + JSON.stringify(formData));
          await axios
            .post(vm.apiUrl + 'AddOrder', formData, {
              headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
              },
            })
            .then(function (response) {
              if (Object.keys(response.data).length != 0) {
                vm.orderId = response.data.orderId
                vm.$toast.open({
                  message: '建立委託單完成!',
                  type: 'success',
                })

                vm.sendBidFbMessageConsumer(
                  localStorage.userId,
                  '5d2065991dc94b0001da9c53',
                  '&orderId=' + vm.orderId
                )
                vm.$router.push('orderdone')
              }
              // console.log(response.data);
              vm.isLoading = false
            })
            .catch(function (error) {
              // console.log(error);
              vm.$toast.open({
                message: '失敗: ' + error,
                type: 'error',
              })
              vm.isLoading = false
            })
        })()
      } else {
        vm.$toast.open({
          message: '送出失敗',
          type: 'error',
        })
        vm.$modal.show('dialog', {
          title: '🙋請聯絡客服',
          text: '請聯絡客服⚡ 系統異常!',
          buttons: [
            {
              title: '👉聯絡客服',
              handler: () => {
                window.location = 'https://m.me/2266831083395361'
              },
            },
          ],
        })
      }
    },
    selectStore: function () {
      const vm = this
      if (vm.checkMobile == '1' && vm.selectedStore == 'UNIMARTC2C') {
        window.open(
          vm.apiUrl +
            'CepayMap?userId=' +
            localStorage.userId +
            '&logisticsSubType=' +
            vm.selectedStore +
            '&device=1'
        )
      } else if (vm.checkMobile == '0' && vm.selectedStore == 'UNIMARTC2C') {
        window.open(
          vm.apiUrl +
            'CepayMap?userId=' +
            localStorage.userId +
            '&logisticsSubType=' +
            vm.selectedStore +
            '&device=0'
        )
      } else {
        window.open(
          vm.apiUrl +
            'CepayMap?userId=' +
            localStorage.userId +
            '&logisticsSubType=' +
            vm.selectedStore +
            '&device=0'
        )
      }
    },
    sendBidFbMessageConsumer: function (userId, blockId, messageData) {
      const vm = this

      ;(async function post() {
        let formData = {}
        await axios
          .post(
            vm.chatbotFbUrl +
              userId +
              '/send?chatfuel_token=' +
              vm.chatfuelToken +
              '&chatfuel_block_id=' +
              blockId +
              messageData,
            formData,
            {
              headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
              },
            }
          )
          .then(function (response) {
            var data = response.data
            if (data.result == 'ok') {
              vm.$toast.open({
                message: '發送訊息!',
                type: 'success',
              })
            }
          })
          .catch(function (error) {
            // console.log(error);
            vm.$toast.open({
              message: '發送訊息失敗: ' + error,
              type: 'error',
            })
          })
      })()
    },
    checkUnChatbotSignin: function () {
      const vm = this

      try {
        if (
          vm.$route.query.userId &&
          vm.$route.query.userImage &&
          vm.$route.query.userName
        ) {
          localStorage.userId = decodeURI(vm.$route.query.userId)
          localStorage.userImage = decodeURI(vm.$route.query.userImage)
          localStorage.userName = decodeURI(vm.$route.query.userName)
          vm.userId = decodeURI(vm.$route.query.userId)
          vm.userImage = decodeURI(vm.$route.query.userImage)
          vm.userName = decodeURI(vm.$route.query.userName)
        }
      } catch (e) {
        // console.info(e);
        alert(e)
      }

      if (localStorage.userId == undefined) {
        vm.$modal.show('dialog', {
          title: '🙋您尚未登入FB會員',
          text: '請先登入才能使用此服務喔⚡',
          buttons: [
            {
              title: '👉用FB登入',
              handler: () => {
                window.location = 'https://m.me/2266831083395361'
              },
            },
          ],
        })
        // vm.$router.push("alibabaorder");
        return true
      } else {
        return false
      }
    },
    queryMapInfo: function () {
      const vm = this
      let formData = {
        userId: localStorage.userId,
      }
      axios
        .post(vm.apiUrl + 'QueryMapInfo', formData, {
          headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
          },
        })
        .then(function (response) {
          if (Object.keys(response.data).length != 0) {
            vm.mapInfo = response.data
            localStorage.setItem('mapInfo', vm.mapInfo)
          } else {
            vm.mapInfo = JSON.parse(localStorage.getItem('mapInfo'))
          }

          // console.log(response.data);
          vm.isLoading = false
        })
        .catch(function (error) {
          // console.log(error);
          vm.$toast.open({
            message: '失敗: ' + error,
            type: 'error',
          })
          vm.isLoading = false
        })
    },
  },
  watch: {
    'from.name': function () {
      const vm = this
      localStorage.setItem('name', vm.from.name)
    },
    'from.phone': function () {
      const vm = this
      localStorage.setItem('phone', vm.from.phone)
    },
    'from.address': function () {
      const vm = this
      localStorage.setItem('address', vm.from.address)
    },
    'from.email': function () {
      const vm = this
      localStorage.setItem('email', vm.from.email)
    },
    internationalTransportationSelected: function () {
      const vm = this
      if (vm.internationalTransportationSelected == '空運') {
        vm.taxSelected = '包稅'
      }
      if (vm.internationalTransportationSelected == '海快') {
        vm.taxSelected = '不包稅'
      }
    },
    taxSelected: function () {
      const vm = this
      if (
        vm.taxSelected == '不包稅' &&
        vm.internationalTransportationSelected == '空運'
      ) {
        alert('目前空運不支援不包稅')
      }
      if (
        vm.taxSelected == '包稅' &&
        (vm.internationalTransportationSelected ==
          '海快 (未滿10公斤以10公斤計算)' ||
          vm.internationalTransportationSelected == '海快')
      ) {
        alert('目前海快不支援包稅')
      }
    },
    shippingTypeSelected: function () {
      const vm = this
      if (vm.shippingTypeSelected == 'deliveryStore') {
        vm.isStoreShow = true
        vm.ishomeDeliveryShow = false
      } else {
        vm.isStoreShow = false
        vm.ishomeDeliveryShow = true
      }
    },
    queryProfile: function () {
      const vm = this
      const isValid = 1

      let formData = {
        userId: localStorage.userId,
        isValid: isValid,
      }

      axios
        .post(vm.apiUrl + 'QueryProfile', formData, {
          headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
          },
        })
        .then(function (response) {
          if (Object.keys(response.data).length != 0) {
            if (response.data[0] != null) {
              vm.profileInfo = response.data[0]

              vm.profileInfo.user_name = vm.from.name
              vm.profileInfo.user_address = vm.from.address
              vm.profileInfo.user_phone = vm.from.phone
              vm.profileInfo.email = vm.from.email
            }
          }
          // console.log(response.data);
          vm.isLoading = false
        })
        .catch(function (error) {
          // console.log(error);
          vm.$toast.open({
            message: '讀取會員失敗: ' + error,
            type: 'error',
          })
        })
    },
  },
  computed: {},
  mounted() {
    const vm = this
    vm.isLoading = true
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0

    // Event snippet for 進入機器人收貨資料填寫頁面 conversion page
    vm.$ga.event('event', 'conversion', {
      send_to: 'AW-700538278/aWw0CJqP4rIBEKa7hc4C',
      value: 1.0,
      currency: 'TWD',
    })

    vm.checkUnChatbotSignin()
    vm.queryMapInfo()

    if (vm.$route.query.isStore == '1') {
      vm.shippingTypeSelected = 'deliveryStore'
      vm.isStoreShow = true
      vm.ishomeDeliveryShow = false
    }

    if (vm.$store.prodInfos != undefined) {
      vm.prodInfos = vm.$store.prodInfos
    } else if (JSON.parse(localStorage.getItem('prodInfos')) != undefined) {
      vm.prodInfos = JSON.parse(localStorage.getItem('prodInfos'))
    }

    if (vm.prodInfos == undefined) {
      vm.$modal.show('dialog', {
        title: '🙋請聯絡客服',
        text: '請聯絡客服⚡ 系統異常!',
        buttons: [
          {
            title: '👉聯絡客服',
            handler: () => {
              window.location = 'https://m.me/2266831083395361'
            },
          },
        ],
      })
    }

    if (localStorage.getItem('address') != undefined) {
      vm.from.address = localStorage.getItem('address')
    }
    if (localStorage.getItem('name') != undefined) {
      vm.from.name = localStorage.getItem('name')
    }
    if (localStorage.getItem('phone') != undefined) {
      vm.from.phone = localStorage.getItem('phone')
    }
    if (localStorage.getItem('email') != undefined) {
      vm.from.email = localStorage.getItem('email')
    }
    vm.queryProfile()
  },
}
</script>
